import pack from '../../package.json'

import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// import { renderRoutes } from 'react-router-config';
import { Persistor, Store } from './ReduxStore';
import '../scss/App.scss';
import { Layout, RouterNonContainer } from '../config';
import { CacheProvider } from '@emotion/react';
import emotionCache from '../emotionCache';
import SessionExpiredModal from '../components/containers/SessionExpiredModal/SessionExpiredModal';
import AuthGate from '../components/containers/AuthGate/AuthGate';
import ErrorBoundary from '../components/containers/ErrorBoundary/ErrorBoundary';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

class App extends Component {
  render() {
    console.log('version: ', pack['version']) //update version on package.json

    return (
      <Provider store={Store}>
        <CacheProvider value={emotionCache}>
          <PersistGate
            loading={null}
            persistor={Persistor}
          >
            <HashRouter>
              <ErrorBoundary>
                <React.Suspense fallback={loading()}>
                  <Switch>
                    {
                      RouterNonContainer.map((route, idx) => (route.component ? (
                        <Route
                          key={idx} // eslint-disable-line
                        path={route.path}
                        exact={route.exact}
                        render={(props: any) => (
                          <route.component {...props} />
                        )}
                      />
                    ) : (null)))
                  }
                  <Route path="/" render={props => <Layout {...props} />} />
                </Switch>
              </React.Suspense>
              </ErrorBoundary>
          </HashRouter>
          <AuthGate />
          <SessionExpiredModal />
        </PersistGate>
      </CacheProvider>
    </Provider>
    );
  }
}

export default App;
